// These are only used for a typeahead and not expecting to add new statuses, so hard-coding these rather than making a service call
export const PRINT_JOB_STATUSES = [
  'IN_PROGRESS',
  'ERROR',
  'RIP',
  'PRINTED',
  'CUT',
  'PLATED',
  'ON_HOLD_FOR_ISSUE',
  'ON_HOLD_FOR_GANG_FIXING',
  'REMOVED_FROM_ON_HOLD_FOR_ISSUE',
  'COATED',
  'ERROR_LOADING',
  'READY_TO_RIP',
  'AT_A_TABLE',
  'WAITING_FOR_GRAPHICS',
  'HALF_PRINTED',
  'LOADED_ONTO_PRESS',
  'SENT_TO_PRESS',
  'LOADED_ONTO_ENGRAVER',
  'ENGRAVING',
  'RELEASED_TO_RIP',
  'DRAWING',
  'FAILED_TO_LOAD_ONTO_PRESS',
  'FAILED_TO_DRAW',
  'RIP_COMPLETE',
  'LABEL_PRINTED',
  'AT_HEAT_TRANSFER',
  'RELOADED_ON_GARMENT_PRESS',
  'WAITING_FOR_GANG_POSITION_ASSIGNMENT',
  'HALF_RIP_COMPLETE',
  'LOADED_ONTO_PRESS_BACKSIDE',
  'LOADED_ONTO_PRESS_FRONTSIDE',
  'FAILED_TO_RIP',
  'BEING_GANG_FIXED',
  'FAILED_TO_DRAW_AWAITING_REDRAW',
  'READY_FOR_LINE_SIDE_REPLENISHMENT_REQUEST',
  'TRANSFER_TO_RIP',
  'FAILED_TO_TRANSFER_TO_RIP',
  'PRINTING_IN_PROGRESS',
  'QUEUED_FOR_PRINT_AND_APPLY',
  'ASSIGNED_TO_OVEN_TRAY',
  'DRAW_GANGS_WORK_ENQUEUED',
  'HEAT_TRANSFER_PAPER_REPRODUCTION_REQUESTED',
  'HEAT_TRANSFER_PAPER_MATCHED_WITH_SUBSTRATE',
  'HEAT_TRANSFER_APPLIED_TO_SUBSTRATE',
  'HEAT_TRANSFER_COMPLETE',
  'MATERIAL_PARTIALLY_CHECKED_IN',
  'MATERIAL_CHECK_IN_COMPLETE',
  'HOOPED',
  'RAISED_PRINT_APPLIED',
  'HALF_PRINTED_FRONTSIDE',
  'HALF_PRINTED_BACKSIDE',
  'LASER_CUT',
  'SENT_TO_PLATER',
  'LOADED_ONTO_PLATER',
  'SENT_TO_PRESS_FRONTSIDE',
  'SENT_TO_PRESS_BACKSIDE'
];

export const MONITOR_EVENTS = [
    'released-to-rip',
    'rip-in-progress',
    'rip-complete',
    'failed-to-rip',
    'loaded',
    'failed-to-load',
    'printing',
    'printed',
    'failed-to-print',
    'raised-print-applied',
    'cut',
    'laser-cut',
    'cutting',
    'loaded-for-cutting',
    'aborted',
    'job-progression',
];